<template>
  <v-container fluid class="fill-height">
    <template v-if="!initFlag">
      <v-skeleton-loader type="article"></v-skeleton-loader>
    </template>
    <template v-else>
      <v-row dense>
        <v-col cols="8">
          <!-- 工具详情 -->
          <v-card tile>
            <v-card-title>
              <v-row align="center">
                <v-icon color="teal" class="mdi-rotate-90" large
                  >mdi-window-minimize</v-icon
                >
                <span class="title-text text-h6">{{
                  toolDetailVisible ? "工具说明" : tool.name
                }}</span>
              </v-row>
              <v-spacer />
              <v-btn color="primary" text class="mr-2" :to="`/tool/${tool.id}`"
                >创建新任务</v-btn
              >
              <v-icon @click="toolDetailVisible = !toolDetailVisible">{{
                toolDetailVisible ? "mdi-chevron-up" : "mdi-chevron-down"
              }}</v-icon>
            </v-card-title>
            <v-card-text v-show="toolDetailVisible">
              <v-row dense>
                <v-col cols="2">
                  <v-row justify="center">
                    <v-col cols="auto">
                      <v-img
                        :src="Utility.RES_SERVER + tool.logo"
                        contain
                        width="80"
                        :title="tool.resultType"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="10">
                  <v-row dense>
                    <v-col cols="12">
                      <span class="text-h6">{{ tool.name }}</span>
                      <span class="caption ml-4 deep-orange--text"
                        >版本号:{{ tool.version }}</span
                      >
                      <v-btn
                        x-small
                        outlined
                        color="primary"
                        class="ml-3 mt-0 pl-1 pr-1"
                        @click="onFav"
                      >
                        <v-icon color="red" x-small>{{
                          !tool.userFavId ? "mdi-heart-outline" : "mdi-heart"
                        }}</v-icon>
                        <span
                          v-if="tool.favNum > 0"
                          class="ml-1 red--text caption"
                          >{{ tool.favNum }}</span
                        >
                      </v-btn>
                    </v-col>
                    <v-col cols="12" class="text-caption">{{
                      tool.note
                    }}</v-col>
                    <v-col cols="12" class="text-button deep-orange--text">{{
                      tool.point == 0 ? `限时免费` : `所需积分:${tool.point}`
                    }}</v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- 输入参数 -->
          <v-card class="mt-2" tile>
            <v-card-title>
              <v-row align="center">
                <v-icon color="teal" class="mdi-rotate-90" large
                  >mdi-window-minimize</v-icon
                >
                <span class="title-text text-h6">分析结果下载</span>
              </v-row>
              <v-spacer />
              <v-btn
                color="primary"
                text
                class="mr-2"
                v-one-click
                @click="onDownloadToolTaskResultFile"
                >结果文件下载</v-btn
              >
              <v-icon @click="toolParamVisible = !toolParamVisible">{{
                toolParamVisible ? "mdi-chevron-up" : "mdi-chevron-down"
              }}</v-icon>
            </v-card-title>
            <v-card-text v-show="toolParamVisible">
              <p v-for="(item, index) in taskParams" :key="index" class="ma-0">
                {{ item.name }} = <code>{{ item.value }}</code>
              </p>
            </v-card-text>
          </v-card>

          <!-- 分析结果 -->
          <v-card tile class="mt-2" min-height="500">
            <v-card-title class="pl-1">
              <v-icon color="teal" class="mdi-rotate-90" large
                >mdi-window-minimize</v-icon
              >分析结果
              <code class="caption ml-2">任务号: {{ toolTask.id }}</code>
              <v-btn
                icon
                color="primary"
                class="ml-2"
                :disabled="refreshDisabled"
                @click="onRefresh"
              >
                <v-icon>mdi-sync</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-row justify="center">
                <v-col
                  v-if="toolTask.status == 1"
                  cols="auto"
                  class="text-h4 deep-orange--text mt-16"
                  >当前任务正在排队，请耐心等待...</v-col
                >
                <v-col
                  v-else-if="toolTask.status == 2"
                  cols="auto"
                  class="text-h4 deep-orange--text mt-16"
                  >当前任务正在运行中...</v-col
                >
                <v-col
                  v-else-if="toolTask.status == 4"
                  cols="auto"
                  class="text-h4 deep-orange--text mt-16"
                  >当前任务运行失败，失败原因：{{ toolTask.message }}</v-col
                >
                <v-col v-else>
                  <component
                    v-if="!!resultComponent"
                    ref="resultComponent"
                    :is="resultComponent"
                    v-bind="chartCptProps"
                  ></component>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- 右侧说明 -->
        <v-col cols="4">
          <v-card tile class="fill-height">
            <v-card-text>
              <tool-help-tab
                v-if="toolHelps && toolHelps.length"
                :tool-id="tool.id"
                :items="toolHelps"
              ></tool-help-tab>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>
<script>
/* eslint-disable no-console */
import {
  getToolTask,
  favTool,
  // downloadToolExample,
  downloadToolTaskResultFile,
} from "@/plugins/api";
import ToolHelpTab from "@/views/Component/ToolHelpTab.vue";

export default {
  data() {
    return {
      initFlag: false,
      id: null,
      billData: {},
      resultComponent: null,

      toolDetailVisible: false,
      toolParamVisible: false,

      refreshDisabled: false,
    };
  },
  computed: {
    chartCptProps() {
      let ret = {
        tool: {
          type: this.tool.resultType,
          params: this.billData.resultParams,
          coder: this.billData.coder,
        },
        exportFileName: `${this.tool.name}-${this.toolTask.id}`,
        dataSourceParam: { toolTask: this.toolTask },
        width: this.tool.width,
        height: this.tool.height,
      };
      return ret;
    },
    toolTask() {
      return this.billData.toolTask;
    },
    tool() {
      return this.billData.tool;
    },
    taskParams() {
      return this.billData.taskParams;
    },
    toolHelps() {
      return this.billData.helps;
    },
  },
  watch: {
    "$route.params.id"(value) {
      if (value && this.$router.currentRoute.fullPath == `/tool/task/${value}`)
        this.init();
    },
  },
  methods: {
    init() {
      let id = this.$route.params && this.$route.params.id;
      if (!id) return; // 路由中指定了参数，不会到这里来，如果url中去掉了id，则会到404
      this.id = id;
      this.initFlag = false;
      this.loadToolTask();
    },
    loadToolTask() {
      getToolTask(this.id).then((res) => {
        let d = res.data;
        this.billData = d;
        this.initFlag = true;
        this.loadChartComponent();
      });
    },
    loadChartComponent() {
      let toolResultType = this.tool.resultType;
      this.resultComponent = () =>
        import(`@/views/Component/ChartLib/${toolResultType}`);
    },
    onRefresh() {
      this.refreshDisabled = true;
      this.$nextTick(() => this.loadToolTask());
      setTimeout(() => {
        this.refreshDisabled = false;
      }, 10000);
    },
    onFav() {
      favTool(this.tool.id).then((res) => {
        let msg = this.tool.userFavId ? "取消收藏成功" : "加入收藏成功";
        this.$message.success(msg);
        this.tool.favNum = res.data.favNum;
        this.tool.userFavId = res.data.userFavId;
      });
    },
    async onDownloadToolTaskResultFile() {
      // let dt = this.toolTask.spDataType;
      // if (dt == 1) { // 用户上传文件: toolTask.spDataValue所对应的文件(如果包含了分组信息，则下载压缩包input.zip)
      //   if (this.tool.spGroup) {
      //     downloadToolTaskResultFile({ id: this.id, fileName: 'input.zip' });
      //   } else {
      //     let filePath = this.toolTask.spDataValue;
      //     let fileName = filePath.substr(filePath.lastIndexOf('/'));
      //     downloadToolTaskResultFile({ id: this.id, fileName: fileName });
      //   }
      // } else if (dt == 2) { // 用户输入文本: 下载input.txt
      //   await downloadToolTaskResultFile({ id: this.id, fileName: 'input.txt' });
      // } else if (dt == 3) { // 使用示例文件: 直接下载示例文件(示例文件的下载由后端处理:如果包含分组文件，则下载压缩包input.zip)
      //   downloadToolExample(this.tool.id);
      // }
      downloadToolTaskResultFile({ id: this.id, fileName: "input.zip" });
      this.toolParamPanelIndex = this.toolParamPanelIndex == 0 ? undefined : 0;
    },
  },
  created() {
    this.init();
  },
  components: { ToolHelpTab },
};
</script>
